/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * field to filter for alarm search:
 *   * ALL : All fields
 *   * NAME : alarm name/alias
 *   * DESCRIPTION : alarm description
 *   * STATION : station name
 */
export enum AlarmSearchFilter {
  ALL = 'ALL',
  NAME = 'NAME',
  DESCRIPTION = 'DESCRIPTION',
  STATION = 'STATION'
}
